import { Badge } from './ui/badge';

const STATUS_COLORS = {
  open: 'bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-900/30 dark:text-blue-400 dark:border-blue-800',
  completed: 'bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-400 dark:border-emerald-800',
  in_progress: 'bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-900/30 dark:text-amber-400 dark:border-amber-800',
  paused: 'bg-yellow-100 text-yellow-800 border-yellow-200 dark:bg-yellow-900/30 dark:text-yellow-300 dark:border-yellow-800',
  scheduled: 'bg-purple-100 text-purple-800 border-purple-200 dark:bg-purple-900/30 dark:text-purple-400 dark:border-purple-800',
  pending: 'bg-orange-100 text-orange-800 border-orange-200 dark:bg-orange-900/30 dark:text-orange-400 dark:border-orange-800',
  cancelled: 'bg-gray-100 text-gray-600 border-gray-200 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-700',
  canceled: 'bg-gray-100 text-gray-600 border-gray-200 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-700',
};

const LABELS = {
  open: 'Open',
  completed: 'Completed',
  in_progress: 'In Progress',
  paused: 'Paused',
  scheduled: 'Scheduled',
  pending: 'Pending',
  cancelled: 'Cancelled',
  canceled: 'Cancelled',
};

/** Strip Excel `="..."` artifact from job numbers */
export function cleanJobNumber(num) {
  if (!num) return '';
  const s = String(num).trim();
  const m = s.match(/^="?(.+?)"?$/);
  return m ? m[1] : s;
}

export function JobStatusBadge({ status, className = '' }) {
  const key = (status || '').toLowerCase().replace(/\s+/g, '_');
  const colors = STATUS_COLORS[key] || 'bg-muted text-muted-foreground border-border';
  const label = LABELS[key] || status || 'Unknown';
  return (
    <Badge
      variant="outline"
      className={`text-[10px] font-semibold px-2 py-0.5 ${colors} ${className}`}
      data-testid={`job-status-${key}`}
    >
      {label}
    </Badge>
  );
}

export function PaymentStatusBadge({ status, className = '' }) {
  const key = (status || '').toLowerCase();
  const colors = key === 'paid'
    ? 'bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-400'
    : key === 'partial'
    ? 'bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-900/30 dark:text-amber-400'
    : 'bg-muted text-muted-foreground border-border';
  return (
    <Badge
      variant="outline"
      className={`text-[10px] font-semibold px-2 py-0.5 ${colors} ${className}`}
      data-testid={`payment-status-${key}`}
    >
      {status || 'Unpaid'}
    </Badge>
  );
}
